import { useCallback } from "react";
import type { FeishuStatus } from "../../../lib/api-types.js";
import { FeishuPanel } from "../../OrganizationDetail/FeishuPanel.js";
import type { OnboardingStepProps } from "../types.js";

/**
 * Step 1 — 关联飞书。直接复用 FeishuPanel（自带凭据表单 / 连接状态 / 10s 轮询）。
 * 就绪判定：已连接 且 已同步出至少一个部门。
 */
export function Step1Feishu({ onReadyChange }: OnboardingStepProps): JSX.Element {
  const handleStatus = useCallback(
    (s: FeishuStatus) => {
      onReadyChange(s.connected && s.departmentCount > 0);
    },
    [onReadyChange],
  );

  return <FeishuPanel onStatusChange={handleStatus} />;
}
